import React from 'react';
import { SvgIcon } from '@material-ui/core';
const Trust = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { viewBox: "0 0 20 12" }),
    React.createElement("path", { d: "M14 0L16.29 2.29L11.41 7.17L7.41 3.17L0 10.59L1.41 12L7.41 6L11.41 10L17.71 3.71L20 6V0H14Z" })));
export default Trust;
